import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const INSTALL_AVAILABLE_EVENT = 'foodbook-install-available';
const INSTALL_CLEARED_EVENT = 'foodbook-install-cleared';

const registerServiceWorker = () => {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) {
    return;
  }

  const register = () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((error) => {
        console.warn('[PWA] Service worker registration failed:', error);
      });
  };

  if (document.readyState === 'complete') {
    register();
    return;
  }

  window.addEventListener('load', register, { once: true });
};

const setupInstallPrompt = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    window.__foodbookDeferredInstallPrompt = event;
    window.dispatchEvent(new Event(INSTALL_AVAILABLE_EVENT));
  });

  window.addEventListener('appinstalled', () => {
    window.__foodbookDeferredInstallPrompt = null;
    window.dispatchEvent(new Event(INSTALL_CLEARED_EVENT));
  });
};

setupInstallPrompt();
registerServiceWorker();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
